import React, { useEffect, useState } from "react";
import "./register.css";
import Logo from "../../asset/images/Logo1.png";
import { Link, useNavigate } from "react-router-dom";
import Image from "../../asset/images/image1.jpeg";
import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchUser } from "../../reducer/userActions";


const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const dispatch = useDispatch();


    useEffect(() => {
        const savedUser = localStorage.getItem("teslaUserInfo");
        const accessToken = localStorage.getItem("teslaUserAccessToken");

        if (savedUser && accessToken) {
            navigate("/dashboard");
        }
    }, [navigate]);



    const handleInput = (e) => {
        const { name, value } = e.target;
        if (name === "email") setEmail(value);
        if (name === "password") setPassword(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const dataToSend = {
            email,
            password,
        };

        try {
            const response = await axios.post('https://teslasafebroker.com/api/login', dataToSend);
            console.log('Registration successful');

            setEmail("");
            setPassword("");

            // ✅ Save token and redirect to dashboard
            localStorage.setItem("teslaUserAccessToken", response.data.token);
            localStorage.setItem("teslaUserInfo", JSON.stringify(response.data.user));


            dispatch(fetchUser());
            setTimeout(() => {
                navigate("/dashboard");
            }, 2000);
            setLoading(false);
        } catch (error) {
            let errorMessage = "Something went wrong. Please try again.";

            if (error.response) {
                console.error('Server responded with error:', error.response.data);

                if (error.response.status === 500) {
                    errorMessage = "Something went wrong, try again";
                } else {
                    errorMessage = error.response.data.message || "Invalid username or password";
                }
            } else if (error.request) {
                console.error('No response received:', error.request);
                errorMessage = "No response from server. Please check your internet connection.";
            } else {
                console.error('Request setup error:', error.message);
                errorMessage = "An unexpected error occurred.";
            }

            setLoading(false);
            setError(errorMessage);

            setTimeout(() => {
                setError("");
            }, 10000);
        }
    };

    return (
        <div className="registration_container">
            <section className="registration image">
                <div className="style"></div>
                <div className="style"></div>
                <img src={Image} alt="register_image" />
            </section>

            <section className="registration content">
                <header className="register_header">
                    <Link to="/"><img src={Logo} alt="logo" /></Link>
                </header>

                <div className="register_body">
                    <h2>Welcome Back</h2>
                    <p>Access your account and manage your investments with ease.</p>
                    {/* <button className="google">Sign In With Google</button>
                    <p>--- or ---</p> */}

                    <form onSubmit={handleSubmit}>
                        <input
                            onChange={handleInput}
                            value={email}
                            type="email"
                            name="email"
                            placeholder="Email"
                            required
                        />
                        <input
                            onChange={handleInput}
                            value={password}
                            type="password"
                            name="password"
                            placeholder="Password"
                            required
                        />
                        <p><Link to="/forgotten_password"><span>Forgotten password</span></Link></p>
                        <button type="submit" disabled={loading}>
                            {loading ? "Loading..." : "Login"}
                        </button>
                    </form>

                    <p className="error">{error}</p>

                    <p>New to Tesla Broker? <Link to="/signup"><span className="blue">Join Us</span></Link></p>
                </div>

                <footer className="register_footer"></footer>
            </section>
        </div>
    );
};

export default Login;
